import React, { useEffect, useState } from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import RichTextEditor from '../RichTextEditor';

interface CommunityFormProps {
    ticket_group_code: string;
    items: Item[];
    tier: string;
    currency: string;
    amount: string;
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onTierChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onCurrencyChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onAmountChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

interface Item {
    ticket_id: number;
    ticket_group_code: string;
    // Add more properties as per your item structure
}

export default function TicketGroupCode({
    items,
    ticket_group_code,
    tier,
    amount,
    currency,
    onTicketGroupCodeChange,
    onTierChange,
    onAmountChange,
    onCurrencyChange
}: CommunityFormProps) {
    
    return (
        <>
            <Form.Group className="mb-3" controlId="formCategory">
                <label className='text-sm mb-2'>Ticket Group Code</label>
                <Form.Select aria-label="Select Category" className='bg-gray-200 py-3' value={ticket_group_code} onChange={onTicketGroupCodeChange}>
                    <option value=""> Select Ticket Group Code</option>
                    {items.map((item) => (
                        <option key={item.ticket_id} value={item.ticket_group_code}>
                            {item.ticket_group_code}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formTier">
                <label className='text-sm mb-2'>Tier</label>
                <FloatingLabel controlId="floatingInput" label="Tier" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Tier"
                        value={tier}
                        className='bg-gray-200'
                        onChange={onTierChange}
                    />
                </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formTier">
                <label className='text-sm mb-2'>Currency</label>
                <FloatingLabel controlId="floatingInput" label="Currency" className="mb-3">
                    <Form.Control
                        type="text"
                        placeholder="Currency"
                        value={currency}
                        className='bg-gray-200'
                        onChange={onCurrencyChange}
                    />
                </FloatingLabel>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formAmount">
                <label className='text-sm mb-2'>Amount</label>
                <FloatingLabel controlId="floatingInput" label="Amount" className="mb-3">
                    <Form.Control
                        type="number"
                        placeholder="Amount"
                        value={amount}
                        className='bg-gray-200'
                        onChange={onAmountChange}
                    />
                </FloatingLabel>
            </Form.Group>
        </>
    );
}
